/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.WalkinManager {

    import IWLSelectedService = Meevo.Plugins.WalkinManager.AddToWaitlist.IWLSelectedService;
    import EmployeeGenderSearchEnum = Meevo.Model.EmployeeGenderSearchEnum;
    import Employee = Meevo.Model.Employee;
    import IService = Meevo.Plugins.WalkinManager.AddToWaitlist.IService;

    export class WLMSelectedServicesController implements ng.IComponentController {
        selectedServices: IWLSelectedService[];
        currentService: IService;
        currentEmployee: Employee;
        currentEmployeePreference: EmployeeGenderSearchEnum;
        deleteService: ({serviceId: string}) => void;
        addService: () => void;

        public getEmployeePreference(employeePreference: EmployeeGenderSearchEnum, employee?: Employee): string {
            switch (employeePreference) {
                case EmployeeGenderSearchEnum.AnyMale:
                    return 'Male Only';
                case EmployeeGenderSearchEnum.AnyFemale:
                    return 'Female Only';
                case EmployeeGenderSearchEnum.AnyEmployee:
                    return 'First Available';
                case EmployeeGenderSearchEnum.SpecificEmployee:
                    return !!employee ? employee.displayName : '';
                default:
                    return '';
            }
        }
    }

    angular.module('meevo.plugins.walkinManager')
        .component('meevoWlmSelectedServices', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/walkinManager/components/selected-services/selected-services.template.html',
            controller: WLMSelectedServicesController,
            controllerAs: '$ctrl',
            bindings: {
                selectedServices: '=',
                currentService: '<',
                currentEmployee: '<',
                currentEmployeePreference: '<',
                deleteService: '&',
                addService: '&',
            }
        });
}
